import { render, staticRenderFns } from "./notBillTable.vue?vue&type=template&id=f18cfd6c&scoped=true&"
import script from "./notBillTable.vue?vue&type=script&lang=js&"
export * from "./notBillTable.vue?vue&type=script&lang=js&"
import style0 from "./notBillTable.vue?vue&type=style&index=0&id=f18cfd6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18cfd6c",
  null
  
)

export default component.exports